import React from "react";
import { FaGithub, FaLinkedin, FaSoundcloud } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

const Footer = () => {
  return (
    <div className="footer">
      <a
        className="footer-icon"
        href="https://github.com/Kalekdan"
        target="_blank"
        rel="noreferrer"
        aria-label="GitHub profile"
        title="Visit my GitHub"
      >
        <FaGithub />
      </a>
      <a
        className="footer-icon"
        href="https://linkedin.com/in/joe-rickard"
        target="_blank"
        rel="noreferrer"
        aria-label="LinkedIn profile"
        title="Visit my LinkedIn"
      >
        <FaLinkedin />
      </a>
      <a
        className="footer-icon"
        href="https://soundcloud.com/kalekdan"
        target="_blank"
        rel="noreferrer"
        aria-label="SoundCloud profile"
        title="Listen on SoundCloud"
      >
        <FaSoundcloud />
      </a>
      <a
        className="footer-icon"
        href="mailto:joe@joerickard.co.uk"
        aria-label="Send me an email"
        title="Send me an email"
      >
        <MdEmail />
      </a>
    </div>
  );
};

export default Footer;
